import type { Interval } from '@/hooks/api/api.types';

export const commonIntervals: Interval[] = ['24h', '7d', '30d', '6m', '1y', 'ytd'];

export const intervalLabelMap: Record<Interval, string> = {
  '24h': '1D',
  '7d': '1W',
  '30d': '1M',
  '6m': '6M',
  '1y': '1Y',
  ytd: 'YTD',
};

export const intervalValueMap: Record<Interval, number> = {
  '24h': 2,
  '7d': 7,
  '30d': 30,
  '6m': 180,
  '1y': 365,
  ytd: 365,
};

export const getStyle = (isActive: boolean): string => {
  if (isActive) {
    return 'ring-1 ring-highlight-border bg-selection-background text-selection-foreground hover:bg-selection-hover cursor-default';
  }

  return 'ring-1 ring-border-secondary text-text-primary hover:ring-[0.5px] hover:ring-text-primary';
};
